export let p = [
    { label: "Apple", url: "https://reurl.cc/NX1Mae" },
    { label: "Spotify", url: "https://reurl.cc/nn63Ve" },
    { label: "KKBOX", url: "https://reurl.cc/pmnNdx" },
    {
        label: "Google",
        url:
            "https://podcasts.google.com/feed/aHR0cHM6Ly9hcGkuc291bmRvbi5mbS92Mi9wb2RjYXN0cy82OTUxNGEwZS1mM2UyLTRkZmQtOTk1ZC03YTRmMzAxYjc2MWEvZmVlZC54bWw",
    },
    { label: "SoundOn", url: "https://sndn.link/shinyblind", icon: "fa fa-podcast" },
];
export let d = [
    {
        label: "漢聲電台「聽見陽光的心跳」",
        url: "https://www.voh.com.tw/tw/Program/ugC_Program_Detail.aspx?ID=193&Time=N",
        icon: "fa fa-podcast",
    },
];
export let setting = {
    // title: "盲裡偷賢",
    subt: "專訪視障朋友與服務團體的廣播節目",
    des: "想聽更多，歡迎鎖定每週日晚上9:10",
};
